<template>
  <div class="rightModal">
    <Input
      label="servers.diskName"
      placeholder="servers.enterDiskName"
      id="diskName"
      v-model="form.diskName"
      :state="validateState('diskName')"
    />

    <b-form-group
      :label="$t('forms.vd.storageVolume')"
      :state="validateState('storageVolume')"
    >
      <multiselect
        v-model="form.storageVolume"
        :options="storageList"
        track-by="id"
        label="name"
        :loading="loading"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.vd.storageVolume')"
        :show-no-results="false"
      />
    </b-form-group>

    <RangeSlider
      id="total_disk"
      v-model="form.total_disk"
      min="1"
      max="1000"
      unit="GB"
      :disabled="form.storageVolume == ''"
    />

    <div v-if="estimate != ''" class="info">
      <span class="text"
        >{{ $t('global.selectedDiskSize') }}:
        {{ $customFunctions.convertGBtoMB(form.total_disk) }} MB</span
      ><br />
      <span class="text"
        >{{ $t('global.price') }}:
        {{ estimate.total_price ? estimate.total_price : 0 }} $</span
      >
      <ul v-if="estimate.info && estimate.info.length > 0">
        <li v-for="(item, index) in estimate.info" :key="index">
          &bull; {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateAttachDiskImages',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    vmId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        diskName: '',
        storageVolume: '',
        total_disk: 0,
      },
      storageList: [],
      estimate: '',
      loading: false,
    }
  },
  validations: {
    form: {
      diskName: {
        required,
      },
      storageVolume: {
        required,
      },
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getStorages()
  },
  methods: {
    getStorages() {
      this.getStorageList().then((res) => {
        this.setStorageList(res)
      })
    },
    getStorageList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `iaas/storage-volumes?position=id|desc&virtual_machine_id=${this.getVmId}`
        )
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    setStorageList(res) {
      if (res && res.data && res.data.length > 0) {
        this.storageList = res.data
      }
    },
    totalDiskChange() {
      this.estimate = ''
      if (this.form.storageVolume != '') {
        this.getEstimate().then((res) => {
          if (res) this.estimate = res
        })
      }
    },
    getEstimate() {
      let params = {
        hdd_size: this.$customFunctions.convertGBtoMB(this.form.total_disk),
        storage_volume: this.form.storageVolume.id,
        is_this_months_price: '1',
      }

      return new Promise((resolve, reject) => {
        ApiService.post(`billing/iaas/virtual-disk/estimate`, params)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.diskName,
        size: this.$customFunctions.convertGBtoMB(this.form.total_disk),
        storage_volume_ref: this.form.storageVolume.id,
        auto_attach: '1',
      }
      ApiService.put(`iaas/virtual-machines/${this.getVmId}/set-disk`, params)
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    'form.total_disk'() {
      this.totalDiskChange()
    },
  },
}
</script>

<style lang="scss" scoped>
.estimate-info {
  font-size: 12px;
  ul {
    margin-top: 10px;
  }
}
</style>
